import { fetchHTML } from './utils-fetch-html.js';

class CartTotal extends HTMLElement {
  connectedCallback() {
    this.unsubscribeCartUpdated = subscribe('cart:updated', () => {
      this.updateCartTotal();
    });
  }

  disconnectedCallback() {
    this.unsubscribeCartUpdated();
  }

  /**
   * Add cart count
   */
  async updateCartTotal() {
    try {
      const html = await fetchHTML(`${Shopify.routes.root}?section_id=fetch-cart-total`);
      const target = html.querySelector('cart-total').cloneNode(true);
      this.replaceWith(target);
    } catch (error) {
      console.log(error.message);
    }
  }
}

customElements.define('cart-total', CartTotal);
